import React from "react";
import "./sobre-historico-style.css";
import CardInfo from "../card-historico";
import Periodos from "../historico-periodos";

function SobreHistorico(props) {
    const todosPeriodos= [];
    if (props !== undefined) {
        props.data.historico_disciplinas.forEach((historico) => {
            if (historico.periodo !== undefined) {
                todosPeriodos.push(historico.periodo);
            }
        });
    }

    const isBrowser = () => typeof window !== 'undefined';

    const handleClick = () => {
        if (!isBrowser()) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="cards">
            <Periodos items={todosPeriodos}/>
            <div className="primeira-col">
                {props.data && props.data.historico_disciplinas.map((historico, index) => (
                    <div key={index} id={index.toString()}>
                        <h1>{historico.periodo}</h1>
                        <CardInfo key={index} data={historico}/>
                    </div>
                ))}
                <h1 className="title-det-historico">DETALHES DO HISTÓRICO</h1>

                <div className="container-cards-historico">

                    <table>
                        <thead>
                        <tr>
                            <th>Descrição</th>
                            <th>Observação</th>
                        </tr>
                        </thead>
                        <tbody>
                        {props.data && props.data.historico_obs.map((observacao, index) => (
                            <tr key={index}>
                                <td>{observacao.descricao}:</td>
                                <td>
                                    <p>
                                        {observacao.obs}
                                    </p>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <button
                onClick={() => handleClick()}
                className="ButtonUp"
            >
                <img src="/images/ArrowUp.svg" alt=""/>
            </button>
        </div>

    );
}

export default SobreHistorico;
